module.exports = __webpack_public_path__ + "assets/img/ftr-func-1.68a0ec2c.png";